import { DsFormsExcelSheetErrorInterface } from '../../interfaces/forms-excel/ds-forms-excel-sheet-error.interface';

export class DsFormsExcelSheetError {
  /**
   *
   */
  column: number;

  /**
   *
   */
  columnName: string;

  /**
   *
   */
  error: string;

  /**
   *
   */
  line: number;

  /**
   * Creates an instance of DsFormsExcelSheetError.
   *
   * @param json JSON data
   */
  constructor(json: DsFormsExcelSheetErrorInterface) {
    this.column = json.column;
    this.columnName = json.columnName;
    this.error = json.error;
    this.line = json.line;
  }
}
